import WebCam from "react-webcam"
import React, { useState} from "react"
import "../../css/Visualizarpdf.css"

import { Worker } from '@react-pdf-viewer/core';
// Import the main Viewer component
import { Viewer } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// default layout plugin
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles of default layout plugin
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import axios from "axios";

import upload from "../../assets/Subir.svg"

//import pdf from "../../../src/PagosLicencia.pdf"

function Vistapdf(url) {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    // pdf file onChange state
    const [pdfFile, setPdfFile] = useState(null);

    // pdf file error state
    const [pdfError, setPdfError] = useState('');

    const [btnAvalible, setbtnAvalible] = useState(false)
    //datos del archivo
    const [dataFile,setdataFile] = useState(null);

    const [btndown, setbtndown] = useState(false);
    // handle file onChange event
    const allowedFiles = ['application/pdf'];

    const choosePdf = React.useCallback(() => {
        this.props.choosepdf(pdfFile);
        /*props.choosepdf(pdfFile);*/

        //console.log(pdfFile);
    });
    //console.log("asdasdas: ", url.url);
    return (
        <div className="container">         
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer fileUrl={url.url}
                    plugins={[defaultLayoutPluginInstance]}></Viewer>
            </Worker>
        </div>
    );
}


export default Vistapdf;
